import { debug } from "/vodalys/.jslibs/";
const log = debug('TalkTo:UidProvider')

let uidProviders = new Map<String, Function>()

export function registerUidProvider(key: String, provider: Function) {

    if (uidProviders.has(key)) throw new Error('canot register the same uid provider key twice')

    log('registerUidProvider', key/* , provider */)

    uidProviders ??= new Map<String, Function>()
    uidProviders.set(key, provider)
}

export function getUidProvider(key: String) {
    // log('getUidProvider', key)
    return uidProviders.get(key)
}

import talkToUidProvider from './talkto.uid_provider.parcel.exemple'

registerUidProvider('talkto_uid_provider', talkToUidProvider)